// 首页统计数据

import request from '@/untils/request'


// 首页统计数据
export const statist = (data) => {
    return request.post("/outpatient/index/statist", data )
}

// 首页代办统计数据
export const statistV2 = (params) => {
    return request.get("/outpatient/index/statist/v2", {params} )
}

// 首页经营统计数据
export const manageReport = (params) => {
    return request.get("/outpatient/boss/manageReport", {params} )
}

// 首页字典数据
export const dict = (params) => {
    return request.get("/outpatient/index/dict", {params} )
}

// 首页统计数据 =》老板工作台 =》健康档案 / 患者档案
export const docphrPage = (params) => {
    return request.get("/outpatient/docphr/page", {params} )
}

// 首页统计数据 =》老板工作台 =》库存金额管理相关 / 西药库报表
export const XYKdgsReport = (data) => {
    return request.post("/outpatient/dgsDpurcTable/dgsReport", data )
}
// 首页统计数据 =》老板工作台 =》库存金额管理相关 / 西药房报表
export const XYFdgsReport = (params) => {
    return request.post("/outpatient/dugdpurctable/dugReport", data )
}
// 首页统计数据 =》老板工作台 =》库存金额管理相关 / 中药库报表
export const ZYKdgsReport = (params) => {
    return request.post("/outpatient/purctcmtable/dgsTcmReport", data )
}
// 首页统计数据 =》老板工作台 =》库存金额管理相关 / 中药房报表
export const ZYFdgsReport = (params) => {
    return request.post("/outpatient/dugpurctcmtable/dugTcmReport", data )
}


// 首页统计数据 =》老板工作台 =》应付款相关 / 供应商应付金额记录表-分页
export const supplierPage = (params) => {
    return request.get("/outpatient/supplier/page", {params} )
}
// 首页统计数据 =》老板工作台 =》应付款相关 / 供应商应付金额记录表-信息
export const getSupplierPage = (params) => {
    return request.get("/outpatient/supplier/{id}", {params} )
}

// 首页统计数据 =》老板工作台 =》排行榜 医生开放
export const drxDoctorNum = (data) => {
    return request.post("/outpatient/boss/drxDoctorNum", data )
}
// 首页统计数据 =》老板工作台 =》排行榜 药品排行
export const drxDrugNum = (data) => {
    return request.post("/outpatient/boss/drxDrugNum", data )
}


// 首页统计数据 =》护士工作台 =》护理执行表

export const NurseWork = (params) => {
    return request.get("/outpatient/exetable/page", { params } )
}

// 首页统计数据 =》医师工作台 =》挂号列表-分页

export const registerPage = (params) => {
    return request.get("/outpatient/register/page", { params } )
}

// 首页统计数据 =》医师工作台 =》就诊列表-分页

export const seedoctorPage = (params) => {
    return request.get("/outpatient/seedoctor/page", { params } )
}



// 首页统计数据 =》药师工作台 =》西药处方列表-分页
export const rxmainPage = (params) => {
    return request.get("/outpatient/dis/selectPatientInfo", { params } )
}

// 首页统计数据 =》药师工作台 =》中药处方列表-分页
export const tcmrxmainPage = (params) => {
    return request.get("/outpatient/tcmDis/selectPatientInfo", { params } )
}

// 首页统计数据 =》药师工作台 =》效期预警数 西药库
export const XYXQ = (params) => {
    return request.get("/outpatient/expireWarn", { params } )
}
// 首页统计数据 =》药师工作台 =》效期预警数 西药房
export const XYFXQ = (params) => {
    return request.get("/outpatient/dugdpurctable/expireWarn", { params } )
}
// 首页统计数据 =》药师工作台 =》效期预警数 中药库
export const ZYXQ = (params) => {
    return request.get("/outpatient/purctcmtable/expireWarn", { params } )
}
// 首页统计数据 =》药师工作台 =》效期预警数 中药房
export const ZYFXQ = (params) => {
    return request.get("/outpatient/dugpurctcmtable/expireWarn", { params } )
}


// 首页统计数据 =》药师工作台 =》库存预警数 西药库
export const XYYJ = (params) => {
    return request.get("/outpatient/alert/list", { params } )
}
// 首页统计数据 =》药师工作台 =》库存预警数 西药房
export const XYFYJ = (params) => {
    return request.get("/outpatient/pharmacyAlert/list", { params } )
}
// 首页统计数据 =》药师工作台 =》库存预警数 中药库
export const ZYYJ = (params) => {
    return request.get("/outpatient/tcmAlert/list", { params } )
}
// 首页统计数据 =》药师工作台 =》库存预警数 中药房
// export const ZYFYJ = (params) => {
//     return request.get("/outpatient/dugpurctcmtable/expireWarn", { params } )
// }


// 首页统计数据 =》药师工作台 =》调价预警数 西药库
export const XYTJ = (params) => {
    return request.get("/outpatient/dgsDpurcAdjust/selAdjustInfo", { params } )
}
// 首页统计数据 =》药师工作台 =》调价预警数 西药房
export const XYFTJ = (params) => {
    return request.get("/outpatient/dugDpurcAdjust/selAdjustDugInfo", { params } )
}
// 首页统计数据 =》药师工作台 =》调价预警数 中药库
export const ZYTJ = (params) => {
    return request.get("/outpatient/dgsDpurcTcmAdjust/selAdjustTcmInfo", { params } )
}
// 首页统计数据 =》药师工作台 =》调价预警数 中药房
export const ZYFTJ = (params) => {
    return request.get("/outpatient/dugDpurcTcmAdjust/selAdjustTcmDugInfo", { params } )
}

// 获取所有在线用户
export const allOnline = (params) => {

    return request.get("/outpatient/index/allOnline", { params } )

}

// 暴露

export default{

	statist,allOnline

}